export const LineColorVariableNames = {
  'wst-system-line-1-color': 'wst-system-line-1-color',
  'wst-system-line-2-color': 'wst-system-line-2-color'
};
export const LineVariableNames = {
  ...LineColorVariableNames,
  'wst-system-line-1-width': 'wst-system-line-1-width',
  'wst-system-line-2-width': 'wst-system-line-2-width'
};
//# sourceMappingURL=line.js.map